import {useSelector} from "react-redux";
import { RootState } from '../../Store/Store';
import {Ability, AbilityBuilder, PureAbility} from '@casl/ability';

export const PRICING = "Pricing";
export const CART_MANAGEMENT = "CartManagement";
export const ORDERS = "Orders";
export const SIGN_UP = "Signup";

const ability = new PureAbility();
export default (action: string) => {
    ability.update(useCreateAbility())
    return ability.can('enact', action);
};

export function useCreateAbility() {
    const {can, rules} = new AbilityBuilder(Ability);
    const permissions = useSelector((state: RootState) => state.auth.permissions);
    if(permissions) {
        permissions.forEach( function(permission) {can('enact', permission)});
    }

    return rules;
}
